<template>
  <div>
    <van-cell-group>
      <van-cell center title="余额（元）" :label="dataForm.balance">
        <template #right-icon>
          <div class="check-cash">
            <van-button color="#F96527" plain hairline type="info" @click.prevent="onShowCash">提现</van-button>
          </div>
        </template>
      </van-cell>
      <van-cell title="收入（元）" :value="dataForm.totalAmount" />
      <van-cell title="提现（元）" :value="dataForm.cash" />
      <van-cell title="提现记录" is-link @click.prevent="record" />
      <van-cell center title="预期到账（元）" :label="dataForm.expectAmount" is-link @click="getExpected" />
      <van-cell title="我的账户" is-link @click.prevent="goMyAccount" />
    </van-cell-group>
    <van-popup v-model="showCash" closeable close-icon-position="top-left">
      <div class="show-pop">
        <div class="balance-css">提现金额</div>
        <van-field
          ref="fieldInput"
          clearable
          v-model="cash"
          :rules="[{ required: true, message: '请填写提现金额' }]"
        >
          <template #left-icon>
            <div>￥</div>
          </template>
        </van-field>
        <div class="balance-css common-balance" v-if="isBalance">
          <span>当前余额 {{dataForm.balance}} 元,</span>
          <span class="all-balance" @click.prevent="allBalance">全部提现</span>
        </div>
        <div class="balance-css balance-css1 common-balance" v-if="!isBalance">
          <span>当前余额 {{dataForm.balance}} 元,余额不足！</span>
        </div>
        <div class="funds-but">
          <van-button
            round
            block
            type="info"
            :disabled="isdisabled"
            native-type="submit"
            @click.prevent="onCash"
          >提现</van-button>
          <div class="bottom-illustrate">
            <p>详细说明</p>
            <p>提现门槛为0.00元</p>
            <p>提现手续费为0%</p>
            <p>本次提现将扣除手续费￥0元</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast } from 'vant';
export default {
  data() {
    return {
      label: '4000',
      income: '200000',
      withdraw: '3500',
      dataForm: '',
      showCash: false,
      isdisabled: false,
      cash: null,
      isBalance: true
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'cash': {
      handler: function () {
        let that = this
        if (that.cash > that.dataForm.balance) {
          that.isdisabled = true
          that.isBalance = false
        } else if (this.dataForm.balance == 0 || that.cash == 0) {
          that.isdisabled = true
        } else {
          that.isdisabled = false
          that.isBalance = true
        }
      }
    },
  },
  methods: {
    record() {
      this.$router.push('/record/details')
    },
    goMyAccount() {
      this.$router.push({ path: '/myAccount/details', query: { account: 'account' } })
    },
    getExpected() {
      this.$router.push('/expected/details')
    },
    getData() {
      let that = this
      let phone = localStorage.getItem('phoneNo')
      that.$fetchPost(URL.postAmount.url, that.$toFormData({ phone: phone })).then(res => {
        that.dataForm = res.data.data
      })
    },
    onShowCash() {
      let that = this
      // if (that.dataForm.balance == 0) {
      //   Toast('余额不足')
      // } else {
        that.showCash = true
      //   that.$nextTick(() => {
      //     that.$refs.fieldInput.focus()
      //   })
      // }
    },
    allBalance() {
      this.cash = this.dataForm.balance ? this.dataForm.balance : ''
    },
    onCash() {
      let that = this
      let data = {
        userId: localStorage.getItem('userid'),
        agentMobile: that.dataForm.agentMobile,
        cashAmount: that.cash
      }
      that.$fetchPost(URL.postCash.url, that.$toFormData(data)).then(res => {
        if (res.data.code == 9999) {
          Toast(res.data.msg)
        } else {
          that.getData()
          Toast(res.data.msg)
          that.showCash = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.check-cash {
  .van-button {
    height: 30px;
  }
}
.van-popup {
  width: 100%;
  height: 100%;
}
.show-pop {
  padding: 55px 5px;
  .van-cell {
    line-height: 48px;
    font-size: 30px;
  }
  .balance-css {
    font-size: 0.2rem;
    padding: 0 16px;
  }
  .common-balance{
    margin-top: 10px;
  }
  .balance-css1 {
    color: red;
  }
  .all-balance {
    font-size: 0.24rem;
    font-weight: 600;
    color: #FC6F0C;
  }
}
.funds-but{
  .van-button{
    width: 355px;
    height: 42px;
    margin: 67.5px auto 20px auto;
    border-radius: 5px;
    background: url('./img/withdraw-but.png') no-repeat 100%;
    background-size: 100% 100% ;
    border: none;
  }
}
.bottom-illustrate{
  width: 335px;
  margin: auto;
  line-height: 1.5;
  font-size: 14px;
  color: #666666;
}

</style>